import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  getSupportDetailRequest,
  getSupportDetailRequestSuccess,
  getSupportDetailRequestError,
} from "../../../slices/teams/members/GetSupportDetailSlice";

export const GetSupportDetail = (id) => async (dispatch) => {
  try {
    dispatch(getSupportDetailRequest());

    const response = await axiosInstance.get(`${endpoints.getSupport}/${id}`, {
      headers: { "Content-Type": "application/json" },
    });

    dispatch(getSupportDetailRequestSuccess(response.data));
    return response.data;
  } catch (error) {
    const _error = {
      data: error?.response?.data?.message || error?.message,
      status: error?.response?.status,
    };
    dispatch(getSupportDetailRequestError(_error));
    throw _error;
  }
};
